import { toggleItems } from '@src/components/toggleItems';

$(() => {
  const $itemSections = $('.items-section');
  $itemSections.each(function () {
    const $items = $(this).find('.toggle-item');
    toggleItems($items);
  });
});
